import {styled} from "@mui/material/styles";
import Container from "@mui/material/Container";

const StyledContainer = styled(Container)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  textAlign: "center",
});

export default StyledContainer;
